import { render, staticRenderFns } from "./SuorganizatorEdit.vue?vue&type=template&id=13068bb6&scoped=true&"
import script from "./SuorganizatorEdit.vue?vue&type=script&lang=js&"
export * from "./SuorganizatorEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13068bb6",
  null
  
)

export default component.exports